import { render, staticRenderFns } from "./SrmContract.vue?vue&type=template&id=4011c096&scoped=true"
import script from "./SrmContract.vue?vue&type=script&lang=js"
export * from "./SrmContract.vue?vue&type=script&lang=js"
import style0 from "./SrmContract.vue?vue&type=style&index=0&id=4011c096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011c096",
  null
  
)

export default component.exports